import React from 'react';
import styled from 'styled-components';

import { Form, Space, Typography } from 'antd';
import FormItemFactory from './FormItemFactory';
import WithRenderingQuestion from './WithRenderingQuestion';

import { toSentenceCase } from 'helpers/StringHelper';

const { Title } = Typography;

const StyledSpace = styled(Space)`
  width: 100%;
  position: relative;
  margin-top: 18px;
`;

const StyledForm = styled(Form)`
  padding: 24px;
  background: #fbfbfb;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
`;

const SingleInstanceForm = ({
  form,
  fields,
  formTitle,
  formDescription,
  hasRenderingQuestion,
  renderingQuestion,
  initialValues,
}) => {
  return (
    <StyledForm form={form} initialValues={initialValues} layout="vertical">
      <Title level={5}>{formTitle}</Title>
      <div dangerouslySetInnerHTML={{ __html: formDescription }}></div>
      <StyledSpace direction="vertical" size="middle">
        <WithRenderingQuestion
          hasRenderingQuestion={hasRenderingQuestion}
          renderingQuestion={renderingQuestion}
        >
          {fields.map((field) => (
            <FormItemFactory
              key={field.id}
              form={form}
              required={field.required}
              label={field.label}
              name={field.name}
              placeholder={field.placeholder}
              prototypeOf={field.field_type}
              availableOptions={field.available_options}
              documents={initialValues?.documents ?? []}
            />
          ))}
        </WithRenderingQuestion>
      </StyledSpace>
    </StyledForm>
  );
};

export default SingleInstanceForm;
